export const doctrineProfiles = {
  reformed_baptist: "Reformed Baptist",
  baptist: "Baptist",
  reformed: "Reformed",
  lutheran: "Lutheran",
  methodist: "Methodist / Wesleyan",
  anglican: "Anglican",
  catholic: "Roman Catholic",
  orthodox: "Eastern Orthodox",
  broad_evangelical: "Broad Evangelical",
} as const;

export type DoctrineProfileKey = keyof typeof doctrineProfiles;

export function isDoctrineProfileKey(value: string): value is DoctrineProfileKey {
  return Object.hasOwn(doctrineProfiles, value);
}

export function doctrineProfileLabel(value: string): string {
  return isDoctrineProfileKey(value)
    ? doctrineProfiles[value]
    : value.replaceAll("_", " ");
}
